module.exports = __webpack_public_path__ + "img/ab_left2.5884eb8a.png";